import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/authContext';
import { useNavigate, Link } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';

export default function LoginPage() {
  const { login, error: authError, isAuthenticated, loginWithGoogle,  } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError(null);

    if (!email || !password) {
      setLocalError('Please fill in both email and password.');
      return;
    }

    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);

    if (res.ok) {
      navigate('/', { replace: true });
    } else {
      setLocalError(res.error?.response?.data?.message || 'Login failed.');
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setLocalError(null);
    const idToken = credentialResponse.credential;

    const res = await loginWithGoogle(idToken);
    if (res.ok) {
      navigate('/', { replace: true });
    } else {
      setLocalError(
        res.error?.response?.data?.message || 'Google sign-in failed.'
      );
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-brand">
          <div className="auth-brand-logo">
  <img
    src="/logo.png"
    alt="Logo"
    style={{ height: "4em", width: "auto", display: "inline-block" }}
  />
</div>            <div className="auth-brand-text">YieldMap</div>
          </div>
          <h1 className="auth-title">Sign in</h1>
          <p className="auth-subtitle">
            Access your analytics dashboard and tools.
          </p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label className="input-label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="input-field"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </div>

          <div className="input-group">
            <label className="input-label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              className="input-field"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          {(localError || authError) && (
            <div className="error-message">
              {localError || authError}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={submitting}
            style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }}
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div style={{ marginTop: '1rem' }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setLocalError('Google sign-in failed.')}
            useOneTap
          />
        </div>
        <div className="auth-footer">
          Don&apos;t have an account?{' '}
          <Link to="/signup" className="auth-link">
            Sign up
          </Link>
        </div>
      </div>
    </div>
  );
}
